import { createContext } from 'react';

/**
 * Whether the question is to be displayed digitally, or to be exported to PDF (as a question or markscheme).
 * Note: When writing a Question Type, you will be passed displayMode as a prop so you don't need to use this context.
 */
export const DisplayMode = createContext<'digital' | 'pdf' | 'markscheme'>('digital');
